import type React from "react"

/** Background of rows rendered inside an expanded PaginatedTable row. */
export const EXPANDED_ROW_BACKGROUND = "#F1F5F9"

/** Cell under the expand chevron column: the tree strip linking expanded rows to their parent row. */
export const expandedRowSpacerCellStyle: React.CSSProperties = {
  padding: 0,
  width: "1.75rem",
  minWidth: "1.75rem",
  maxWidth: "1.75rem",
  background:
    "linear-gradient(to right, #CBD5E1 0, #CBD5E1 0.875rem, #94A3B8 0.875rem, #94A3B8 calc(0.875rem + 1px), transparent calc(0.875rem + 1px), transparent 100%)",
  borderBottom: "1px solid #E2E8F0",
}
